export default { 
    apiUrl: process.env.REACT_APP_API_URL,
    apiUrlRoot: process.env.REACT_APP_API_ROOT_URL,
    wsUrl: process.env.REACT_APP_WS_URL,
    wsPort: process.env.REACT_APP_WS_PORT,
    wsKey: process.env.REACT_APP_WS_KEY
}

 